<template>
    <div>
        <v-app-bar density="compact">
            <v-tabs v-model="activeTab" bg-color="primary" slider-color="#fff" color="#fff" show-arrows grow>
                <v-tab :value="1" :ripple="false">ホーム</v-tab>
                <v-tab :value="2" :ripple="false">ファンド</v-tab>
                <v-tab :value="3" :ripple="false">メディア</v-tab>
            </v-tabs>
        </v-app-bar>

        <v-window v-model="activeTab">
            <v-window-item :value="1">
                <v-sheet>
                    <div v-if="loggedIn">
                        <TabHome></TabHome>
                    </div>
                    <div v-if="loggedOut">
                        <v-container>
                            <Login></Login>
                        </v-container>
                    </div>
                </v-sheet>
            </v-window-item>

            <v-window-item :value="2">
                <v-sheet>
                    <TabFunds></TabFunds>
                </v-sheet>
            </v-window-item>

            <v-window-item :value="3">
                <v-sheet>
                    <TabMedia />
                </v-sheet>
            </v-window-item>

        </v-window>

    </div>
</template>

<script>
import axios from 'axios'
import Login from '../views/Login.vue'
import TabHome from '../views/TabHome.vue'
import TabFunds from '../views/TabFunds.vue'
import TabMedia from '../views/TabMedia.vue'

export default {
    components: {
        Login,
        TabHome,
        TabFunds,
        TabMedia
    },
    data() {
        return {
            loggedIn: false,
            loggedOut: false,
        }
    },
    created: async function () {
        try {
            await axios.get('/api/login-check')
            this.setLoginState(true)
        } catch (err) {
            this.setLoginState(false)
        }
    },
    methods: {
        setLoginState: function (isLoggedIn) {
            this.loggedIn = isLoggedIn
            this.loggedOut = !isLoggedIn
        }
    },
    computed: {
        activeTab: {
            get() {
                return this.$store.getters.activeTab
            },
            set(value) {
                this.$store.dispatch("setActivetab", value);
            }
        }
    }
}
</script>

<style scoped>
.v-tab.v-tab {
    opacity: 0.4;
}
.v-tab.v-tab.v-tab--selected {
    opacity: 1;
}
</style>